/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Response model for finalizing a video upload
 */
export interface FinalizeUploadResponse { 
    videoId: string;
    status: string;
    message: string;
}

